import React from "react"
import Template from "../../components/Template"
import Translations from "../../../components/Translations"
import img1 from "../../images/indicators/indicators.jpg"

function ACL() {
    const Content = () => {
        return (
            <div className={`flex flex-col gap-5`}>
                <img src={img1} alt='/' className={`border border-gray-700 mt-5 mb-5 w-[20%]`}></img>
                <p className={`text-lg`}><Translations category={"docsACL"} id={1}/></p>
                <p className={`text-lg`}><Translations category={"docsACL"} id={2}/></p>
                <p className={`text-lg`}>
                    <Translations category={"docsACL"} id={3}/>
                    <li><Translations category={"docsACL"} id={4}/></li>
                    <li><Translations category={"docsACL"} id={5}/></li>
                    <li><Translations category={"docsACL"} id={6}/></li>
                </p>
                <p className={`text-lg`}><Translations category={"docsACL"} id={7}/></p>
            </div>
        )
    }
    const config = {
        title: <Translations category={"docs"} id={22}/>,
        previousLink: '/docs/relative-strength-index',
        previousTitle: <Translations category={"docs"} id={21}/>,
        nextLink: '/docs/average-volume',
        nextTitle: <Translations category={"docs"} id={23}/>,
        content: Content(),
    }

    return (
        <Template config={config}/>
    )
}

export default ACL